import { UPDATE_TERM_STORE } from './actionTypes';

export const updateTermsStore = (payLoad) => {
    return {
        type: UPDATE_TERM_STORE,
        payLoad: payLoad
    }
}